module.exports = "data:image/png;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJpbWcvcHJlbG9hZC9sb2dvX29ubHlfZGFya19ibHVyLnBuZyI7"